import one from "../../assets/partners/one.webp";
import two from "../../assets/partners/two.webp";
import three from "../../assets/partners/three.webp";
import four from "../../assets/partners/four.webp";
import five from "../../assets/partners/five.webp";
import six from "../../assets/partners/six.webp";
import seven from "../../assets/partners/seven.webp";
import eight from "../../assets/partners/eight.webp";
import nine from "../../assets/partners/nine.webp";
import ten from "../../assets/partners/ten.jpg";

export const PartnerImageList = [
  { id: 1, name: one },
  { id: 2, name: two },
  { id: 3, name: three },
  { id: 4, name: four },
  { id: 5, name: five },
  { id: 6, name: six },
  { id: 7, name: seven },
  { id: 8, name: eight },
  { id: 9, name: nine },
  { id: 10, name: ten },
];
